import React, { createContext, useState } from 'react';

const initialValues = {
  ratingState: 0,
  setRatingState: () => {
    ('');
  }
};

const RatingFormContext = createContext<any>(initialValues);

const RatingContextProvider: React.FC = ({ children }) => {
  const [stepState, setStepState] = useState(initialValues.ratingState);

  return (
    <RatingFormContext.Provider
      value={{
        stepState,
        setStepState
      }}
    >
      {children}
    </RatingFormContext.Provider>
  );
};
export { RatingContextProvider };
export default RatingFormContext;
